import { useQuery } from '@tanstack/react-query';
import { getDeviceReadingRawData } from '../api/getDeviceReadingRawData';

export const deviceReadingRawDataKey = (unitId, eventId) => ['deviceReadingRawData', String(unitId), String(eventId)];

export const hasEventId = (eventId) => Number(eventId) > 0;

/**
 * The raw OEM message behind one reading. A reading is immutable, so the
 * result never goes stale: reopening the same event is served from the shared
 * `queryClient` cache. Disabled without a unit or a real event id (initial
 * readings start at `rowId: -1`).
 */
export const useDeviceReadingRawData = (unitId, eventId) =>
	useQuery({
		queryKey: deviceReadingRawDataKey(unitId, eventId),
		enabled: Boolean(unitId) && hasEventId(eventId),
		queryFn: () => getDeviceReadingRawData(unitId, eventId),
		staleTime: Infinity,
	});
